// extracted by mini-css-extract-plugin
export var closeButton = "_gy-2";
export var closeButtonIcon = "_gy-3";
export var lightboxContent = "_gy-1";
export var lightboxOverlay = "_gy-0";